import { render } from "./Template.vue?vue&type=template&id=4782e1ed&scoped=true&ts=true"
import script from "./Template.vue?vue&type=script&lang=ts"
export * from "./Template.vue?vue&type=script&lang=ts"

import "./Template.vue?vue&type=style&index=0&id=4782e1ed&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4782e1ed"]])

export default __exports__